import './FunPanel.css'

const STICKERS = [
  '⭐', '🌟', '💫', '✨', '❤️', '💜', '💛', '💚', '💙', '🧡',
  '🌈', '🎨', '🖍️', '🌀', '🌸', '🌺', '🌻', '💐', '🌷', '🌼',
  '🐱', '🐶', '🐰', '🐻', '🐼', '🦁', '🐯', '🦊', '🐨', '🦄',
  '🦋', '🐝', '🐞', '🐸', '🐢', '🦆', '🐧', '🦉', '🐙', '🦀',
  '😀', '😊', '🥳', '🤩', '😻', '👍', '👏', '🙌', '🎉', '🎈',
  '🎁', '🏆', '🎵', '🎶', '⚽', '🎯', '🍕', '🍦', '🍭', '🎠',
]

export function FunPanel({ selectedSticker, onSelectSticker, onEffect, lang = 'he' }) {
  return (
    <details className="fun-panel">
      <summary className="fun-panel-summary">{lang === 'en' ? 'Stickers, motion & effects' : 'סטיקרים, הנפשות ואפקטים'}</summary>
      <div className="fun-panel-body">
        <section className="fun-section">
          <span className="fun-section-title">{lang === 'en' ? 'Stickers — tap to select, then tap the canvas to place' : 'סטיקרים (עם הנפשה קלה בכפתורים) — לחצו לבחור, ואז על הקנבס להדבקה'}</span>
          <div className="fun-stickers-scroll-outer" aria-label={lang === 'en' ? 'Sticker list, scroll for more' : 'רשימת סטיקרים — גלול לעוד'}>
            <div className="fun-stickers">
              {STICKERS.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className={`fun-sticker-btn ${selectedSticker === emoji ? 'selected' : ''}`}
                  onClick={() => onSelectSticker(selectedSticker === emoji ? null : emoji)}
                  title={emoji}
                  aria-pressed={selectedSticker === emoji}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
          {selectedSticker && (
            <p className="fun-sticker-hint">{lang === 'en' ? `Selected: ${selectedSticker} - tap the canvas to place` : `נבחר: ${selectedSticker} - געו בקנבס להדביק`}</p>
          )}
        </section>
        <section className="fun-section">
          <span className="fun-section-title">{lang === 'en' ? 'Effects' : 'אפקטים'}</span>
          <div className="fun-effects">
            <button type="button" className="fun-effect-btn" onClick={() => onEffect('confetti')}>
              {lang === 'en' ? '🎊 Confetti' : '🎊 קונפטי'}
            </button>
            <button type="button" className="fun-effect-btn" onClick={() => onEffect('sparkle')}>
              {lang === 'en' ? '✨ Sparkle' : '✨ ניצוץ'}
            </button>
          </div>
        </section>
      </div>
    </details>
  )
}
